<input type="checkbox" id="nav-toggle" />
<div class="sidebar">
  <div class="sidebar-header" *ngIf="!isInIframe">
    <div class="user-pic">
      <a routerLink="/task">
        <img *ngIf="!darkTheme" src="../../../assets/images/logo.png" alt="" />
        <img *ngIf="darkTheme" src="../../../assets/images/white-logo.png" alt="" />
      </a>
    </div>
    <div class="user-info"></div>
  </div>
  <div class="sidebar-menu">
    <ul>
      <li *ngIf="!this.userDetails?.allocated && hasFeature('preview')">
        <span *ngIf="userDetails?.user_enabled">
          <a [routerLink]='[this.userDetails?.id ? "/preview" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
              <mat-icon class="material-symbols-outlined icon-size">description</mat-icon>
            Preview</a></span>
      </li>
      <li>
        <span>
          <a [routerLink]='[this.userDetails?.id ? "/task" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg width="23" height="24" viewBox="0 0 23 24" fill="#000" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.025 23.4715C14.7417 23.5048 14.5 23.4171 14.3 23.2085C14.1 23.0005 14 22.7548 14 22.4715C14 22.2215 14.0917 22.0005 14.275 21.8085C14.4583 21.6171 14.6833 21.5048 14.95 21.4715C16.5167 21.2548 17.854 20.5925 18.962 19.4845C20.0707 18.3758 20.7333 17.0382 20.95 15.4715C20.9833 15.2048 21.0917 14.9798 21.275 14.7965C21.4583 14.6132 21.6833 14.5215 21.95 14.5215C22.2333 14.5215 22.4793 14.6215 22.688 14.8215C22.896 15.0215 22.9833 15.2632 22.95 15.5465C22.7167 17.6298 21.8583 19.4132 20.375 20.8965C18.8917 22.3798 17.1083 23.2381 15.025 23.4715ZM15.15 19.3965C14.85 19.4798 14.5833 19.4132 14.35 19.1965C14.1167 18.9798 14 18.7048 14 18.3715C14 18.1548 14.0793 17.9588 14.238 17.7835C14.396 17.6088 14.5917 17.4798 14.825 17.3965C15.325 17.2632 15.7583 17.0132 16.125 16.6465C16.4917 16.2798 16.7417 15.8465 16.875 15.3465C16.9583 15.1132 17.0877 14.9175 17.263 14.7595C17.4377 14.6008 17.6333 14.5215 17.85 14.5215C18.1833 14.5215 18.4583 14.6382 18.675 14.8715C18.8917 15.1048 18.9583 15.3715 18.875 15.6715C18.6583 16.5882 18.2127 17.3842 17.538 18.0595C16.8627 18.7342 16.0667 19.1798 15.15 19.3965ZM5.55 22.8965C5.3 22.8965 5.05 22.8465 4.8 22.7465C4.55 22.6465 4.325 22.5048 4.125 22.3215L0.575 18.7715C0.391667 18.5715 0.25 18.3465 0.15 18.0965C0.05 17.8465 0 17.5965 0 17.3465C0 17.0798 0.05 16.8255 0.15 16.5835C0.25 16.3421 0.391667 16.1298 0.575 15.9465L3.75 12.7715C4.13333 12.3882 4.60833 12.1925 5.175 12.1845C5.74167 12.1758 6.21667 12.3632 6.6 12.7465L7.85 13.9965L8.55 13.2965L7.3 12.0465C6.91667 11.6632 6.725 11.1965 6.725 10.6465C6.725 10.0965 6.91667 9.62982 7.3 9.24648L8.725 7.82148C9.10833 7.43815 9.57933 7.24648 10.138 7.24648C10.696 7.24648 11.1667 7.43815 11.55 7.82148L12.8 9.07148L13.5 8.37148L12.25 7.12148C11.8667 6.73815 11.675 6.26715 11.675 5.70848C11.675 5.15048 11.8667 4.67982 12.25 4.29648L15.425 1.12148C15.625 0.921484 15.85 0.771484 16.1 0.671484C16.35 0.571484 16.6 0.521484 16.85 0.521484C17.1 0.521484 17.3457 0.571484 17.587 0.671484C17.829 0.771484 18.05 0.921484 18.25 1.12148L21.8 4.67148C22 4.85482 22.146 5.06715 22.238 5.30848C22.3293 5.55048 22.375 5.80482 22.375 6.07148C22.375 6.32148 22.3293 6.57148 22.238 6.82148C22.146 7.07148 22 7.29648 21.8 7.49648L18.625 10.6715C18.2417 11.0548 17.7707 11.2465 17.212 11.2465C16.654 11.2465 16.1833 11.0548 15.8 10.6715L14.55 9.42148L13.85 10.1215L15.1 11.3715C15.4833 11.7548 15.671 12.2255 15.663 12.7835C15.6543 13.3422 15.4583 13.8132 15.075 14.1965L13.675 15.5965C13.2917 15.9798 12.821 16.1715 12.263 16.1715C11.7043 16.1715 11.2333 15.9798 10.85 15.5965L9.6 14.3465L8.9 15.0465L10.15 16.2965C10.5333 16.6798 10.721 17.1548 10.713 17.7215C10.7043 18.2881 10.5083 18.7632 10.125 19.1465L6.95 22.3215C6.76667 22.5048 6.554 22.6465 6.312 22.7465C6.07067 22.8465 5.81667 22.8965 5.55 22.8965ZM5.55 20.9215L6.6 19.8715L3.05 16.3215L2 17.3715L5.55 20.9215ZM7.675 18.7965L8.725 17.7465L5.175 14.1965L4.125 15.2465L7.675 18.7965ZM12.275 14.1965L13.675 12.7965L10.125 9.24648L8.725 10.6465L12.275 14.1965ZM17.225 9.24648L18.275 8.19648L14.725 4.64648L13.675 5.69648L17.225 9.24648ZM19.35 7.12148L20.4 6.07148L16.85 2.52148L15.8 3.57148L19.35 7.12148Z"
                fill="#667085" />
            </svg>

            Tasks</a></span>
      </li>
      <li>
        <span *ngIf="(userDetails?.userType === 'Super user' || !userDetails?.permission_based || (userDetails?.userType != 'Super user' && 
              userDetails?.permission_based && (userDetails.permissions.includes(3)))) && userDetails?.user_enabled">
          <div routerLinkActive="active">
            <a [routerLink]='[this.userDetails?.id ? "/payment" : "/login"]' style="display: none">Cart</a>
            <a routerLinkActive="active" [routerLink]='[this.userDetails?.id ? "/cart" : "/login"]'>
              <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.25 15.2H12.75C13.0318 15.2 13.302 15.3106 13.5013 15.5075C13.7006 15.7044 13.8125 15.9715 13.8125 16.25C13.8125 16.5285 13.7006 16.7955 13.5013 16.9925C13.302 17.1894 13.0318 17.3 12.75 17.3H3.1875C2.90571 17.3 2.63546 17.1894 2.4362 16.9925C2.23694 16.7955 2.125 16.5285 2.125 16.25V2.6H1.0625C0.780707 2.6 0.510457 2.48938 0.311199 2.29246C0.111942 2.09555 0 1.82848 0 1.55C0 1.27152 0.111942 1.00445 0.311199 0.807538C0.510457 0.610625 0.780707 0.5 1.0625 0.5H3.1875C3.46929 0.5 3.73954 0.610625 3.9388 0.807538C4.13806 1.00445 4.25 1.27152 4.25 1.55V3.65105L4.32756 3.65H14.7974C16.014 3.65 17 4.58975 17 5.75C17 5.9033 16.9819 6.05555 16.9469 6.2057L15.7239 11.4557C15.5008 12.4164 14.6062 13.1 13.5734 13.1H4.32756L4.25 13.0989V15.2ZM3.71875 21.5C3.29606 21.5 2.89068 21.3341 2.5918 21.0387C2.29291 20.7433 2.125 20.3427 2.125 19.925C2.125 19.5073 2.29291 19.1067 2.5918 18.8113C2.89068 18.5159 3.29606 18.35 3.71875 18.35C4.14144 18.35 4.54682 18.5159 4.8457 18.8113C5.14459 19.1067 5.3125 19.5073 5.3125 19.925C5.3125 20.3427 5.14459 20.7433 4.8457 21.0387C4.54682 21.3341 4.14144 21.5 3.71875 21.5V21.5ZM13.2812 21.5C12.8586 21.5 12.4532 21.3341 12.1543 21.0387C11.8554 20.7433 11.6875 20.3427 11.6875 19.925C11.6875 19.5073 11.8554 19.1067 12.1543 18.8113C12.4532 18.5159 12.8586 18.35 13.2812 18.35C13.7039 18.35 14.1093 18.5159 14.4082 18.8113C14.7071 19.1067 14.875 19.5073 14.875 19.925C14.875 20.3427 14.7071 20.7433 14.4082 21.0387C14.1093 21.3341 13.7039 21.5 13.2812 21.5ZM4.25 5.75V11H13.6329L14.875 5.75H4.25Z"
                  fill="#667085" />
              </svg>
              Cart</a>
          </div>
        </span>

        <span *ngIf="(userDetails?.permission_based && (!userDetails.permissions.includes(3))) ||
         !userDetails?.user_enabled">
          <a class="order" style="cursor: default !important;">
           <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.25 15.2H12.75C13.0318 15.2 13.302 15.3106 13.5013 15.5075C13.7006 15.7044 13.8125 15.9715 13.8125 16.25C13.8125 16.5285 13.7006 16.7955 13.5013 16.9925C13.302 17.1894 13.0318 17.3 12.75 17.3H3.1875C2.90571 17.3 2.63546 17.1894 2.4362 16.9925C2.23694 16.7955 2.125 16.5285 2.125 16.25V2.6H1.0625C0.780707 2.6 0.510457 2.48938 0.311199 2.29246C0.111942 2.09555 0 1.82848 0 1.55C0 1.27152 0.111942 1.00445 0.311199 0.807538C0.510457 0.610625 0.780707 0.5 1.0625 0.5H3.1875C3.46929 0.5 3.73954 0.610625 3.9388 0.807538C4.13806 1.00445 4.25 1.27152 4.25 1.55V3.65105L4.32756 3.65H14.7974C16.014 3.65 17 4.58975 17 5.75C17 5.9033 16.9819 6.05555 16.9469 6.2057L15.7239 11.4557C15.5008 12.4164 14.6062 13.1 13.5734 13.1H4.32756L4.25 13.0989V15.2ZM3.71875 21.5C3.29606 21.5 2.89068 21.3341 2.5918 21.0387C2.29291 20.7433 2.125 20.3427 2.125 19.925C2.125 19.5073 2.29291 19.1067 2.5918 18.8113C2.89068 18.5159 3.29606 18.35 3.71875 18.35C4.14144 18.35 4.54682 18.5159 4.8457 18.8113C5.14459 19.1067 5.3125 19.5073 5.3125 19.925C5.3125 20.3427 5.14459 20.7433 4.8457 21.0387C4.54682 21.3341 4.14144 21.5 3.71875 21.5V21.5ZM13.2812 21.5C12.8586 21.5 12.4532 21.3341 12.1543 21.0387C11.8554 20.7433 11.6875 20.3427 11.6875 19.925C11.6875 19.5073 11.8554 19.1067 12.1543 18.8113C12.4532 18.5159 12.8586 18.35 13.2812 18.35C13.7039 18.35 14.1093 18.5159 14.4082 18.8113C14.7071 19.1067 14.875 19.5073 14.875 19.925C14.875 20.3427 14.7071 20.7433 14.4082 21.0387C14.1093 21.3341 13.7039 21.5 13.2812 21.5ZM4.25 5.75V11H13.6329L14.875 5.75H4.25Z"
                  fill="#667085" />
              </svg>
            <span
              [matTooltip]="this.userDetails?.id ? 'You do not have permission to access this menu option.' : ''">Cart</span></a>
        </span>
      </li>

      <li>
        <span *ngIf="(userDetails?.userType === 'Super user' || !userDetails?.permission_based || (userDetails?.userType != 'Super user' && 
              userDetails?.permission_based && (userDetails.permissions.includes(5)))) && userDetails?.user_enabled">
          <a [routerLink]='[this.userDetails?.id ? "/collections" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 21.5C4.70085 21.5 0 16.7991 0 11C0 5.20085 4.70085 0.5 10.5 0.5C16.2991 0.5 21 5.20085 21 11C21 16.7991 16.2991 21.5 10.5 21.5ZM8.0955 19.0503C7.05959 16.853 6.45947 14.4757 6.32835 12.05H2.1651C2.36942 13.6658 3.03862 15.1876 4.0914 16.4303C5.14418 17.673 6.53521 18.5832 8.0955 19.0503ZM8.4315 12.05C8.59005 14.6109 9.3219 17.0165 10.5 19.1396C11.7099 16.9604 12.4167 14.538 12.5685 12.05H8.4315ZM18.8349 12.05H14.6716C14.5405 14.4757 13.9404 16.853 12.9045 19.0503C14.4648 18.5832 15.8558 17.673 16.9086 16.4303C17.9614 15.1876 18.6306 13.6658 18.8349 12.05ZM2.1651 9.95H6.32835C6.45947 7.52427 7.05959 5.14697 8.0955 2.94965C6.53521 3.41677 5.14418 4.32699 4.0914 5.56971C3.03862 6.81243 2.36942 8.33416 2.1651 9.95ZM8.43255 9.95H12.5674C12.416 7.46213 11.7096 5.03971 10.5 2.8604C9.29006 5.03962 8.58328 7.46205 8.4315 9.95H8.43255ZM12.9045 2.94965C13.9404 5.14697 14.5405 7.52427 14.6716 9.95H18.8349C18.6306 8.33416 17.9614 6.81243 16.9086 5.56971C15.8558 4.32699 14.4648 3.41677 12.9045 2.94965Z"
                fill="#667085" />
            </svg>
      
            Collections</a></span>
      
        <span *ngIf="userDetails?.permission_based && (!userDetails.permissions.includes(5)) ||
         !userDetails?.user_enabled">
          <a class="order" style="cursor: default !important;">
            <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 21.5C4.70085 21.5 0 16.7991 0 11C0 5.20085 4.70085 0.5 10.5 0.5C16.2991 0.5 21 5.20085 21 11C21 16.7991 16.2991 21.5 10.5 21.5ZM8.0955 19.0503C7.05959 16.853 6.45947 14.4757 6.32835 12.05H2.1651C2.36942 13.6658 3.03862 15.1876 4.0914 16.4303C5.14418 17.673 6.53521 18.5832 8.0955 19.0503ZM8.4315 12.05C8.59005 14.6109 9.3219 17.0165 10.5 19.1396C11.7099 16.9604 12.4167 14.538 12.5685 12.05H8.4315ZM18.8349 12.05H14.6716C14.5405 14.4757 13.9404 16.853 12.9045 19.0503C14.4648 18.5832 15.8558 17.673 16.9086 16.4303C17.9614 15.1876 18.6306 13.6658 18.8349 12.05ZM2.1651 9.95H6.32835C6.45947 7.52427 7.05959 5.14697 8.0955 2.94965C6.53521 3.41677 5.14418 4.32699 4.0914 5.56971C3.03862 6.81243 2.36942 8.33416 2.1651 9.95ZM8.43255 9.95H12.5674C12.416 7.46213 11.7096 5.03971 10.5 2.8604C9.29006 5.03962 8.58328 7.46205 8.4315 9.95H8.43255ZM12.9045 2.94965C13.9404 5.14697 14.5405 7.52427 14.6716 9.95H18.8349C18.6306 8.33416 17.9614 6.81243 16.9086 5.56971C15.8558 4.32699 14.4648 3.41677 12.9045 2.94965Z"
                fill="#667085" />
            </svg>
            <span
              [matTooltip]="this.userDetails?.id ? 'You do not have permission to access this menu option.' : ''">Collections</span></a>
        </span>
      </li>

      <li>
        <span
          *ngIf="(userDetails?.userType === 'Super user' || !userDetails?.permission_based || (userDetails?.userType != 'Super user' && 
              userDetails?.permission_based && (userDetails.permissions.includes(3) || userDetails.permissions.includes(6)))) && userDetails?.user_enabled">
          <a [routerLink]='[this.userDetails?.id ? "/orders" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.57143 3.83333H3.28571C2.67951 3.83333 2.09812 4.07917 1.66947 4.51675C1.24082 4.95434 1 5.54783 1 6.16667V20.1667C1 20.7855 1.24082 21.379 1.66947 21.8166C2.09812 22.2542 2.67951 22.5 3.28571 22.5H14.7143C15.3205 22.5 15.9019 22.2542 16.3305 21.8166C16.7592 21.379 17 20.7855 17 20.1667V6.16667C17 5.54783 16.7592 4.95434 16.3305 4.51675C15.9019 4.07917 15.3205 3.83333 14.7143 3.83333H12.4286M5.57143 3.83333H12.4286M5.57143 3.83333C5.57143 4.45217 5.81224 5.04566 6.2409 5.48325C6.66955 5.92083 7.25093 6.16667 7.85714 6.16667H10.1429C10.7491 6.16667 11.3304 5.92083 11.7591 5.48325C12.1878 5.04566 12.4286 4.45217 12.4286 3.83333M5.57143 3.83333C5.57143 3.21449 5.81224 2.621 6.2409 2.18342C6.66955 1.74583 7.25093 1.5 7.85714 1.5H10.1429C10.7491 1.5 11.3304 1.74583 11.7591 2.18342C12.1878 2.621 12.4286 3.21449 12.4286 3.83333M5.57143 14.3333L7.85714 16.6667L12.4286 12"
                stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Orders</a></span>

          <span *ngIf="userDetails?.permission_based && (!userDetails.permissions.includes(3) && !userDetails.permissions.includes(6)) ||
         !userDetails?.user_enabled">
          <a class="order" style="cursor: default !important;">
          <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.57143 3.83333H3.28571C2.67951 3.83333 2.09812 4.07917 1.66947 4.51675C1.24082 4.95434 1 5.54783 1 6.16667V20.1667C1 20.7855 1.24082 21.379 1.66947 21.8166C2.09812 22.2542 2.67951 22.5 3.28571 22.5H14.7143C15.3205 22.5 15.9019 22.2542 16.3305 21.8166C16.7592 21.379 17 20.7855 17 20.1667V6.16667C17 5.54783 16.7592 4.95434 16.3305 4.51675C15.9019 4.07917 15.3205 3.83333 14.7143 3.83333H12.4286M5.57143 3.83333H12.4286M5.57143 3.83333C5.57143 4.45217 5.81224 5.04566 6.2409 5.48325C6.66955 5.92083 7.25093 6.16667 7.85714 6.16667H10.1429C10.7491 6.16667 11.3304 5.92083 11.7591 5.48325C12.1878 5.04566 12.4286 4.45217 12.4286 3.83333M5.57143 3.83333C5.57143 3.21449 5.81224 2.621 6.2409 2.18342C6.66955 1.74583 7.25093 1.5 7.85714 1.5H10.1429C10.7491 1.5 11.3304 1.74583 11.7591 2.18342C12.1878 2.621 12.4286 3.21449 12.4286 3.83333M5.57143 14.3333L7.85714 16.6667L12.4286 12"
                stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span
              [matTooltip]="this.userDetails?.id ? 'You do not have permission to access this menu option.' : ''">Orders</span></a>
        </span>   
      </li> 

      <li
        *ngIf="((!this.userDetails?.allocated && this.currentUser?.userType === 'Super user')||(userDetails?.permission_based && userDetails.permissions.includes(USER_CAN_DEPOSIT))) && !this.userDetails?.isSubAccount">
        <span><a [routerLink]='[this.userDetails?.id ? "/deposits" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">add_card</mat-icon>
            Deposits</a>
          </span>
      </li>
       <li *ngIf="!this.userDetails?.allocated && hasFeature('budgets') && !this.userDetails?.cpc && !this.userDetails?.pointsEligible">
        <span *ngIf="userDetails?.user_enabled"><a [routerLink]='[this.userDetails?.id ? "/budget" : "/login"]'
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">credit_card</mat-icon>
            Budgets</a>
          </span>
          <!-- <span *ngIf="this.userDetails?.user_plan === 1 && userDetails?.user_enabled"><a class="order" style="cursor: default !important;">
            <mat-icon class="material-symbols-outlined icon-size" style="cursor: default !important;">credit_card</mat-icon>
            <span matTooltip="This feature is available with deposit access." >Budgets</span></a>
          </span>  -->
          <span *ngIf="!userDetails?.user_enabled"><a class="order" style="cursor: default !important;">
            <mat-icon class="material-symbols-outlined icon-size"
              style="cursor: default !important;">credit_card</mat-icon>
            <span
              [matTooltip]="this.userDetails?.id ? 'You do not have permission to access this menu option.' : ''">Budgets</span></a>
          </span>
      </li> 
      <li *ngIf="!this.userDetails?.allocated && this.userDetails?.userType === 'Super user' && hasFeature('quotes')">
        <span><a [routerLink]='[this.userDetails?.id ? "/quotes" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">article</mat-icon>
            Quotes
          </a></span>
      </li>
      <li *ngIf="this.userDetails?.userType === 'Super user' && hasFeature('multi-user')">
        <span><a [routerLink]='[this.userDetails?.id ? "/users" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">group</mat-icon>
            Users 
          </a></span>
      </li>
      <li
        *ngIf="this.userDetails?.userType === 'Super user' && !this.userDetails?.isSubAccount && this.userDetails?.user_plan==4">
        <span><a [routerLink]='[this.userDetails?.id ? "/sub-accounts" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">corporate_fare</mat-icon>
            Sub Accounts
          </a></span>
      </li>
      <li
        *ngIf="userDetails?.userType === 'Super user' && hasFeature('activity-log')">
        <span><a [routerLink]='[this.userDetails?.id ? "/activity-log" : "/login"]' routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" class="order">
            <mat-icon class="material-symbols-outlined icon-size">history</mat-icon>
            Activity Log
          </a></span>
      </li>
    </ul>
    <ul *ngIf="!isInIframe">
      <li class="logout">
        <div style="width: 150px;">
          <span>
            <a (click)="logout()">
              <img src="../../../assets/images/settings.svg" /> Logout
            </a>
          </span>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="main-content">
  <header>
    <div class="top-bar">
      <h2>
        <label for="nav-toggle">
          <span class="fas fa-bars">
            <img src="../../../assets/images/menu.png" style="width: 20px" />
          </span>
        </label>
        {{ title }}
      </h2>

      <div style="display: flex;">
        <div class="custom-spinner" *ngIf="freeze">
          <mat-spinner [diameter]="35" color="primary">
          </mat-spinner>
          <span class="textdetails">Downloading...{{this.progress }}%</span>
        </div>
      
        <div class="profile-sec" *ngIf="currentUser?.verified">     
          <!-- <div *ngIf="!isChatOpen && (userDetails?.subscribed || subscribe)" class="chat-container" >
            <div class="cs-tooltip">Ask Iris</div>
            <div #chatIcon  class="chat-bot" >
              <div class="img-wrapper">
                <img src="../../../assets/feature-images/iris-logo-animation.gif" alt="chat-bot"  class="animation-icon"   (click)="toggleChat()"  >
              </div>
            </div>
          </div> -->
          <img *ngIf="!userDetails?.photo" src="../../../assets/images/avatar-user.png" alt=""
            style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;" />
          <img *ngIf="userDetails?.photo" class="ph-no-capture" src="{{ this.photo }}" alt=""
            style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;" />      
          <div class="profile-text ph-no-capture" routerLink="profile">
            <p>{{ userDetails?.displayname }}&nbsp;
              <span *ngIf="userDetails?.userType === 'Super user'" class="user-type">({{ userDetails?.userType
                }})</span>
            </p>
            <span class="dark-text">{{ userDetails?.email }}</span>
          </div>

          <button
             class="icon-color"
             mat-icon-button
             [matMenuTriggerFor]="announcementMenu"
             (menuOpened)="onAnnouncementsOpened()"
             [matBadge]="unreadCount"
             matBadgeColor="warn"
             matBadgeSize="small"
             matBadgeOverlap="false"
             [matBadgeHidden]="unreadCount == 0">
             <mat-icon [matTooltip]="'Notifications'">notifications</mat-icon>
          </button>

           <button
             class="icon-color support-ticket-button"
             mat-icon-button
             routerLink="/support-tickets"
             matBadgeColor="warn"
             matBadgeSize="small"
             matBadgeOverlap="false"
             aria-label="Support Tickets">
             <mat-icon [matTooltip]="'Support Tickets'">support_agent</mat-icon>
           </button>

          <div class="idea" routerLink="support">
            <img matTooltip="Feedback on improvements and requirements" [src]="feedback" alt="notifications" />
            </div>

          <button mat-icon-button (click)="toggleTheme()"
            *ngIf="this.userDetails?.subscribed || subscribe || demoView || this.userDetails?.user_plan === 1">
            <mat-icon [matTooltip]="isDarkMode ? 'Light Theme' : 'Dark Theme'">{{ isDarkMode ? 'wb_sunny' :
              'nights_stay' }}</mat-icon>
            </button>
        </div>
      </div>

    </div>
  </header>
  <main class="page-content">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>

</div>

<!-- Announcements Menu -->
<mat-menu [hasBackdrop]="false" #announcementMenu="matMenu" class="announcement-menu" xPosition="before">

  <!-- Header -->
  <div class="menu-header" (click)="$event.stopPropagation()">
    <div class="title">
    <mat-icon class="icon-color">notifications</mat-icon>
    <span>Announcements</span>
    </div>
    <button mat-icon-button (click)="$event.stopPropagation(); closeAnnouncements()">
       <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Filters -->
  <div class="filters-wrapper" (click)="$event.stopPropagation()">
  <mat-tab-group
    [disablePagination]="true"
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="onTabChange($event.index)"
    class="filter-tabs">
    <mat-tab
      *ngFor="let tab of ANOUNCEMENTS_OPTIONS" [label]="tab.label">
    </mat-tab>
  </mat-tab-group>
  </div>

  <!-- List -->
  <div class="announcement-list" (click)="$event.stopPropagation()">

    <div
      class="announcement-item"
      [ngClass]="{ 'unread-announcement': !a.read }"
      *ngFor="let a of announcements">

      <div class="date-announcement">{{ a.date | date:'dd MMM yyyy ' : "GMT"}}</div>
      <div class="title">
        <mat-icon class="type-icon">campaign</mat-icon>
        {{ a.title }}
      </div>
      <div class="announcement-desc">{{ a.description }}</div>

    </div>

    <div class="empty" *ngIf="announcements.length === 0">
      <ngx-spinner [fullScreen]="false" type="ball-clip-rotate"
              size="small"></ngx-spinner>
      {{loadingAnnouncements ? '' : 'No announcements found'}}
    </div>

  </div>

</mat-menu>